import {
  TouchableNativeFeedbackProps,
  TouchableOpacityProps,
  TouchableWithoutFeedbackProps,
  TouchableHighlightProps,
  Insets,
} from 'react-native';

import type { ColorType } from '@types';

export enum TouchableTypeEnum {
  Default = 'default',
  Opacity = 'opacity',
  Highlight = 'highlight',
  WithoutFeedback = 'without-feedback',
}

export interface IBaseTouchableProps
  extends TouchableOpacityProps,
    TouchableHighlightProps,
    TouchableNativeFeedbackProps,
    TouchableWithoutFeedbackProps {
  onPress?: () => void;
  onPressIn?: () => void;
  onPressOut?: () => void;
  onLongPress?: () => void;
  borderless?: boolean;
  rippleColor?: ColorType;
  type?: TouchableTypeEnum;
}

export interface ITouchableProps
  extends Omit<IBaseTouchableProps, 'hitSlop'> {
  hitSlop?: number | Insets;
}
type HitSlopType = Insets | undefined;

export function getHitSlop(hit?: number | Insets): HitSlopType {
  if (!hit) {
    return;
  }

  if (typeof hit === 'number') {
    return {
      top: hit,
      right: hit,
      bottom: hit,
      left: hit,
    };
  }

  return hit;
}
